import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 update_budget_allocation: { message: "idle" },
};

export const update_budget_allocation_Slice = createSlice({
 name: "update_budget_allocation",
 initialState,
 reducers: {
  success_update_budget_allocation: (state, action) => {
   state.update_budget_allocation = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_update_budget_allocation: (state, action) => {
   state.update_budget_allocation = { status: app_consts.FAIL, message: action.payload };
  },
  reset_update_budget_allocation: (state) => {
   state.update_budget_allocation = { status: app_consts.IDLE };
  },
  loading_update_budget_allocation: (state) => {
   state.update_budget_allocation = { status: app_consts.LOADING };
  },
 }
});

export const { success_update_budget_allocation, fail_update_budget_allocation, reset_update_budget_allocation, loading_update_budget_allocation } = update_budget_allocation_Slice.actions;

export default update_budget_allocation_Slice.reducer;